import VueRouter from "vue-router";
import { Box } from "./utils/box";
import { Store } from "vuex";

export const gStore = new Box<Store<any>>()
export const gRouter = new Box<VueRouter>()
export const gVm = new Box<Vue>()